import { UserType } from '@/entities/user'
import { apiClient } from '@/shared/api'

import { TNotice } from '../model/schema'

export type TGetNoticeParams = {
  userType: UserType
  noticeId: number
}

export const getNotice = async ({ userType, noticeId }: TGetNoticeParams) => {
  const { data } = await apiClient.get<TNotice>({
    endpoint: `/support/${userType}/notices/${noticeId}`,
  })

  return data
}
